import ApiCore from '@/api/api-core'
import { ACTIVE_BASE_REST } from '@/api/constants'

export default class ReportsDictionaryConflict extends ApiCore {
  constructor(store) {
    super(store, `${ ACTIVE_BASE_REST }/report/dictionary/conflict`)
  }

  getConflictWithReference(filter, showProgress) {
    return this._request({
      action: 'internal',
      method: 'GET',
      params: filter,
      showProgress
    })
  }

  getConflictWithExternal(filter, showProgress) {
    return this._request({
      action: 'external',
      method: 'GET',
      params: filter,
      showProgress
    })
  }
}